import * as React from 'react';
import { formatLastOpenedDate } from '../../utils/dateFormatting';

type CompletionHeaderProps = {
    isCompleted: boolean;
    lastOpenedAt: Date | null;
};

const CompletionHeader: React.FC<CompletionHeaderProps> = ({ isCompleted, lastOpenedAt }) => {
    if (!isCompleted) {
        return null;
    }

    const timestampText = formatLastOpenedDate(lastOpenedAt);

    return (
        <div className="completion-header-container">
            <div className="completion-header">
                <div className="completion-header-content">
                    <svg 
                        className="completion-header-icon" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                    <div className="completion-header-text">
                        <span className="completion-header-primary">
                            Diesen Fragebogen hast du bereits ausgefüllt
                        </span>
                        {timestampText && (
                            <span className="completion-header-secondary">
                                Zuletzt geöffnet: {timestampText}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompletionHeader;
